import React from 'react';

import { AppBranding } from '../types/appBranding';
import LoadingHeader from '../hocs/ApplicationWrapper/Components/Header/LoadingHeader';
import LoadingPage from '../components/LoadingPage/LoadingPage';

export const UnauthorizedLoadingPage = ({
	branding,
}: {
	branding?: AppBranding;
}) => (
	<>
		<LoadingHeader branding={branding} />
		<LoadingPage />
	</>
);
